import { render, staticRenderFns } from "./ForgetPasswordForm.vue?vue&type=template&id=28b9f284&scoped=true"
import script from "./ForgetPasswordForm.vue?vue&type=script&lang=js"
export * from "./ForgetPasswordForm.vue?vue&type=script&lang=js"
import style0 from "./ForgetPasswordForm.vue?vue&type=style&index=0&id=28b9f284&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28b9f284",
  null
  
)

export default component.exports